import type { FC, ReactNode } from 'react'

import { CalendarPlus, Phone } from 'lucide-react'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@/components/ui/button'
import { BookButton } from '@/components/landing/booking-provider'
import { clinic } from '@/constants/clinic'

/** Quick call and booking actions pinned to the bottom of small screens */
export const MobileActionBar: FC = (): ReactNode => {
    return (
        <div className='fixed inset-x-0 bottom-0 z-30 border-t border-border bg-white/95 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-8px_24px_-16px_rgb(13_37_49/0.25)] backdrop-blur-lg md:hidden'>
            <div className='mx-auto flex max-w-md gap-3'>
                <a
                    href={clinic.phone.href}
                    className={cn(buttonVariants({ variant: 'outline' }), 'flex-1')}
                >
                    <Phone className='size-4 text-brand-600' aria-hidden='true' />
                    Telepon
                </a>

                <BookButton className='flex-[1.4]'>
                    <CalendarPlus className='size-4' aria-hidden='true' />
                    Buat Janji
                </BookButton>
            </div>
        </div>
    )
}
